import * as React from 'react'

import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'

import { CHIP_MAX_WIDTH } from './constants'
import './index.styles.css'

const stylesRefs = {
  chip: 'SimpleChip_chip',
  active: 'SimpleChip_active',
  disabled: 'SimpleChip_disabled',
}

const PADDING_X = 20
const GAP = 4
const TEXT_MAX_WIDTH = CHIP_MAX_WIDTH - PADDING_X - GAP

type Props = {
  label: string | React.ReactNode
  active: boolean
  disabled: boolean
  onClick: () => void
}

const SimpleChip = ({ label, active, disabled, onClick }: Props) => {
  const cx = useClassNames(stylesRefs)

  const color = (disabled: boolean, active: boolean) => {
    if (disabled) {
      return 'grey600'
    }
    if (active) {
      return 'viridian1200'
    } else {
      return 'grey800'
    }
  }

  return (
    <button className={cx('chip', { active, disabled })} onClick={onClick} disabled={disabled}>
      <Box
        flexDirection="row"
        alignItems="flexStart"
        gap="s4"
        style={{ maxWidth: `${TEXT_MAX_WIDTH}px` }}
      >
        <Text.Normal
          size="200"
          weight={active ? 'semibold' : 'normal'}
          color={color(disabled, active)}
          whiteSpace="nowrap"
        >
          {label}
        </Text.Normal>
      </Box>
    </button>
  )
}

export default SimpleChip
